import { call, put, takeLatest, take, select } from "redux-saga/effects";
import {
  loadOpenedProfileInfoSuccess,
  loadMoreOpenedProfilePostsSuccess,
  loadMoreOpenedProfileFollowersSuccess,
  loadMoreOpenedProfileFollowingSuccess,
  loadMoreOpenedProfileCollectionsSuccess,
  cleanOpenedProfilePosts,
  cleanOpenedProfile,
} from "./actions";
import { showAlert } from "../../actions";

import UserApi from "../../api/UserApi";
import PostApi from "../../api/PostApi";
import api from "../../api/api";
import { incrementPostViewsMP } from "../../services/mixpanel";
import { shouldWaitOnAuthDone } from "../../sagas/AuthSaga";

export function* handleLoadOpenedProfileInfoByUsername({ username }) {
  return yield handleLoadOpenedProfileInfo(UserApi.getLoadUserByUsernameUrl(username));
}
export function* handleLoadOpenedProfileInfoById({ id }) {
  yield handleLoadOpenedProfileInfo(UserApi.getLoadUserByIdUrl(id));
}

function* handleLoadOpenedProfileInfo(request) {
  try {
    if (yield shouldWaitOnAuthDone()) {
      yield take("FIREBASE_AUTH_DONE");
    }
    const { data: user } = yield call(api.get, request.url);
    const openedProfileInfo = yield select(state => state.user.openedProfile.info);
    const openedProfileId = openedProfileInfo && openedProfileInfo._id;

    if (openedProfileId !== user._id) {
      yield put(cleanOpenedProfile());
      yield put(cleanOpenedProfilePosts());
    }
    yield put(loadOpenedProfileInfoSuccess(user));
    return user;
  } catch (error) {
    yield put({ type: "LOAD_OPENED_PROFILE_INFO_FAILED", error });
  }
}
export function* handleLoadMoreOpenedProfilePosts({ userId, limit, pagingToken, override }) {
  const loadUserPostsRequest = PostApi.getLoadPostsUrl({
    userId,
    limit,
    pagingToken,
  });
  if (yield shouldWaitOnAuthDone()) {
    yield take("FIREBASE_AUTH_DONE");
  }
  try {
    const { data: { data: posts, pagingToken: newPagingToken } } = yield call(
      api.get,
      loadUserPostsRequest.url,
      loadUserPostsRequest.config
    );
    yield put(loadMoreOpenedProfilePostsSuccess({ posts, limit, pagingToken: newPagingToken, override }));
    incrementPostViewsMP(posts.length);
  } catch (error) {
    yield put({ type: "LOAD_OPENED_PROFILE_INFO_FAILED" });
  }
}

export function* handleLoadMoreOpenedProfileFollowing({ userId, limit, pagingToken, override }) {
  const request = UserApi.getLoadUserFollowingUrl({ userId, limit, pagingToken });
  if (yield shouldWaitOnAuthDone()) {
    yield take("FIREBASE_AUTH_DONE");
  }
  try {
    const { data: { data: following, pagingToken: newPagingToken } } = yield call(api.get, request.url, request.config);
    yield put(loadMoreOpenedProfileFollowingSuccess({ following, limit, pagingToken: newPagingToken, override }));
  } catch (error) {
    yield put(showAlert("Sorry, Something wrong happened !", "error"));
  }
}

export function* handleLoadMoreOpenedProfileFollowers({ userId, limit, pagingToken, override }) {
  const request = UserApi.getLoadUserFollowersUrl({ userId, limit, pagingToken });
  try {
    if (yield shouldWaitOnAuthDone()) {
      yield take("FIREBASE_AUTH_DONE");
    }
    const { data: { data: followers, pagingToken: newPagingToken } } = yield call(api.get, request.url, request.config);
    yield put(loadMoreOpenedProfileFollowersSuccess({ followers, limit, pagingToken: newPagingToken, override }));
  } catch (error) {
    yield put(showAlert("Sorry, Something wrong happened !", "error"));
  }
}

export function* handleLoadMoreOpenedProfileCollections({ userId, limit, pagingToken }) {
  const request = UserApi.getLoadUserCollectionsUrl({ userId, limit, pagingToken });
  try {
    const { data: { data: collections, pagingToken: newPagingToken } } = yield call(
      api.get,
      request.url,
      request.config
    );
    yield put(loadMoreOpenedProfileCollectionsSuccess({ collections, limit, pagingToken: newPagingToken }));
  } catch (error) {
    yield put(showAlert("Sorry, Something wrong happened !", "error"));
  }
}

export function* watchProfileRequests(props) {
  yield takeLatest("LOAD_OPENED_PROFILE_INFO_BY_USERNAME_REQUEST", handleLoadOpenedProfileInfoByUsername);
  yield takeLatest("LOAD_OPENED_PROFILE_INFO_BY_ID_REQUEST", handleLoadOpenedProfileInfoById);
  yield takeLatest("LOAD_MORE_OPENED_PROFILE_POSTS_REQUEST", handleLoadMoreOpenedProfilePosts);
  yield takeLatest("LOAD_MORE_OPENED_PROFILE_FOLLOWING_REQUEST", handleLoadMoreOpenedProfileFollowing);
  yield takeLatest("LOAD_MORE_OPENED_PROFILE_FOLLOWERS_REQUEST", handleLoadMoreOpenedProfileFollowers);
  yield takeLatest("LOAD_MORE_OPENED_PROFILE_COLLECTIONS_REQUEST", handleLoadMoreOpenedProfileCollections);
}



// WEBPACK FOOTER //
// ./src/scenes/OthersProfile/sagas.js